export default __webpack_public_path__ + "static/media/Increaes_sales_sell_more_upload_own.e98f255f.gif";